import {Autocomplete, Box, TextField} from "@mui/material";
import React, {useState} from "react";
import {MultiSearchProps} from "../../components/SearchBox";
import {Tables} from "../../apitypes";
import AvatarImage from "../storage/AvatarImage";
import {useGetWorkOrderQuery} from "./workorder_api";

export default ({onChange, value, label}: MultiSearchProps<Tables<"workOrder">>) => {

    const [filter, setFilter] = useState("");
    const {data} = useGetWorkOrderQuery({
        filter: filter,
        pageSize: 30,
        page: 0,
        sort: [{col: "number", dir: "desc"}]
    })

    return <Autocomplete
        id={"INVc"}
        multiple
        options={data?.result || []}
        autoHighlight
        sx={{minWidth: "200px"}}
        value={value}
        filterOptions={x => x}

        onChange={(e, v: Tables<"workOrder">[]) => onChange(v)}
        getOptionLabel={(option: Tables<"workOrder">) => {
            return option.number;
        }}
        onInputChange={(e, v) => setFilter(v)}
        renderOption={(props, option: Tables<"workOrder">) => {
            const {key, ...rest} = props
            return <Box component="li" sx={{'& > .MuiAvatar-root': {mr: 1}}} key={key} {...rest}>
                <AvatarImage image_url={option.image_url} bucket={"products"}/> {option.number} {option.buyerName}
            </Box>
        }}
        renderInput={(params) => (
            <TextField
                {...params}

                label={label || "Delovni nalogi"}
                variant={"standard"}
            />
        )}
    />

}
